import { useEffect } from "react";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import NavLink from "./NavLink";
import DownloadAppButton from "./DownloadAppButton";

export default function MobileMenu({ open, onClose, links }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm md:hidden"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-x-3 top-3 z-50 rounded-2xl bg-white shadow-2xl md:hidden"
          >
            <div className="flex items-center justify-between border-b border-neutral-100 px-5 py-4">
              <img
                src="/images/landing-v2/hero/shadow-wordmark.svg"
                alt="SHADOW"
                className="h-3.5 w-auto"
              />
              <button
                type="button"
                onClick={onClose}
                aria-label="Close menu"
                className="flex h-9 w-9 items-center justify-center rounded-full text-neutral-700 hover:bg-neutral-100"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <nav className="flex flex-col gap-1 px-3 py-3">
              {links.map((link) => (
                <NavLink
                  key={link.href}
                  href={link.href}
                  onClick={onClose}
                  className="block rounded-lg px-4 py-3 text-base font-medium text-neutral-800 hover:bg-neutral-50"
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
            <div className="px-5 pb-5 pt-2">
              <DownloadAppButton size="md" withIcon className="w-full" location="mobile_menu" onClick={onClose} />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
